export const keys = {
  ESC: "Escape",
  ENTER: "Enter",
  SPACE: " ",
  TAB: "Tab",
};

export function isFocusable(el) {
  const focusable = ["A","INPUT","BUTTON","SELECT","TEXTAREA"];
  const hasTabIndex = el.hasAttribute("tabindex");
  return focusable.includes(el.tagName) || hasTabIndex;
}
